import React from 'react';

export const SHLogoIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_55999_23272)">
      <path
        d="M8.61824 0.9375C7.56029 0.9375 7.03046 2.19978 7.77855 2.93802L27.4742 22.3745C28.2223 23.1127 29.5014 22.5899 29.5014 21.5458V2.10938C29.5014 1.46217 28.9697 0.9375 28.3139 0.9375H8.61824Z"
        fill="url(#paint0_linear_55999_23272)"
      />
      <path
        d="M14.9185 26.3902C15.4795 26.9439 16.4389 26.5518 16.4389 25.7688V14.707C16.4389 14.2216 16.0401 13.8281 15.5482 13.8281H4.33901C3.54555 13.8281 3.14818 14.7748 3.70924 15.3285L14.9185 26.3902Z"
        fill="url(#paint1_linear_55999_23272)"
      />
      <path
        d="M7.11276 28.0622C7.4868 28.4314 8.12636 28.1699 8.12636 27.6479V22.6172C8.12636 22.2936 7.86053 22.0312 7.53261 22.0312H2.43479C1.90581 22.0312 1.6409 22.6624 2.01494 23.0315L7.11276 28.0622Z"
        fill="url(#paint2_linear_55999_23272)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_55999_23272"
        x1="7.02639"
        y1="23.7992"
        x2="29.2176"
        y2="2.34994"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2563EB" />
        <stop offset="1" stopColor="#3B82F6" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_55999_23272"
        x1="7.02639"
        y1="23.7992"
        x2="29.2176"
        y2="2.34994"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2563EB" />
        <stop offset="1" stopColor="#3B82F6" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_55999_23272"
        x1="7.02639"
        y1="23.7992"
        x2="29.2176"
        y2="2.34994"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2563EB" />
        <stop offset="1" stopColor="#3B82F6" />
      </linearGradient>
      <clipPath id="clip0_55999_23272">
        <rect
          width="28.5001"
          height="28.125"
          fill="white"
          transform="translate(1 0.9375)"
        />
      </clipPath>
    </defs>
  </svg>
);
